export enum MetaMenuTypes {
    DEALERSHIPS = 'Dealerships',
    AUTOSHOPS = 'Autoshops',
    BOOK_MEETING = 'Book meeting'
}
